import { LoadUserFail, LoadUserRequest, LoadUserSuccess } from "./userSlice";
import Cookies from "js-cookie";

export const loadUser = (userID) => async (dispatch) => {
  const token = Cookies.get("accessToken");

  if (token) {
    // If the token exists, we consider the user authenticated and dispatch LoadUserRequest first
    dispatch(LoadUserRequest());

    try {
      const response = await fetch(`https://cashback-479780104538.europe-west2.run.app/api/users/${userID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to load user');
      }

      const data = await response.json();
      // Dispatch LoadUserSuccess with the data after a successful response
      dispatch(LoadUserSuccess(data));
    } catch (error) {
      dispatch(LoadUserFail(error.message));
    }
  } else {
    // If there's no token, mark the user as unauthenticated immediately
    dispatch(LoadUserFail('No access token found'));
  }
};
